export default __webpack_public_path__ + "maps-examples-data-driven-symbols-1200-7defcbf26cd4c4fef3bbbbabfdda75b3.png";